export default [
  {
    path: '/admin/apply/shop/category',
    name: 'ShopCategory',
    component: () => import('@/views/apply/shop/category'),
    meta: {
      title: '分类管理',
      headType: 0,
      auth: true
    }
  },
  {
    path: '/admin/apply/shop/product',
    name: 'ShopProduct',
    component: () => import('@/views/apply/shop/product'),
    meta: {
      title: '商品管理',
      headType: 0,
      auth: true
    }
  },
  {
    path: '/admin/apply/shop/product/detail',
    name: 'ShopProductDetail',
    component: () => import('@/views/apply/shop/product/detail'),
    meta: {
      title: '商品详情',
      headType: 0,
      auth: true
    }
  },
  {
    path: '/admin/apply/shop/delivery_template',
    name: 'ShopDeliveryTemplate',
    component: () => import('@/views/apply/shop/delivery_template'),
    meta: {
      title: '配送模板',
      headType: 0,
      auth: true
    }
  },
  {
    path: '/admin/apply/shop/delivery_template/detail',
    name: 'ShopDeliveryTemplateDetail',
    component: () => import('@/views/apply/shop/delivery_template_detail'),
    meta: {
      title: '配送模板详情',
      headType: 0,
      auth: true
    }
  },
  {
    path: '/admin/apply/shop/custom_form',
    name: 'ShopCustomForm',
    component: () => import('@/views/apply/shop/custom_form'),
    meta: {
      title: '自定义表单',
      headType: 0,
      auth: true
    }
  },
  {
    path: '/admin/apply/shop/custom_form/detail',
    name: 'ShopCustomFormDetail',
    component: () => import('@/views/apply/shop/custom_form_detail'),
    meta: {
      title: '自定义表单详情',
      headType: 0,
      auth: true
    }
  },
  {
    path: '/admin/apply/shop/product_tag',
    name: 'ShopProductTag',
    component: () => import('@/views/apply/shop/product_tag'),
    meta: {
      title: '商品标签',
      headType: 0,
      auth: true
    }
  },
  {
    path: '/admin/apply/shop/return_address',
    name: 'ShopReturnAddress',
    component: () => import('@/views/apply/shop/return_address'),
    meta: {
      title: '退货地址',
      headType: 0,
      auth: true
    }
  },
  {
    path: '/admin/apply/shop/return_address/detail',
    name: 'ShopReturnAddressDetail',
    component: () => import('@/views/apply/shop/return_address_detail'),
    meta: {
      title: '退货地址详情',
      headType: 0,
      auth: true
    }
  },
  {
    path: '/admin/apply/shop/full_reduction',
    name: 'ShopFullReduction',
    component: () => import('@/views/apply/shop/full_reduction'),
    meta: {
      title: '满减活动',
      headType: 0,
      auth: true
    }
  },
  {
    path: '/admin/apply/shop/full_reduction/detail',
    name: 'ShopFullReductionDetail',
    component: () => import('@/views/apply/shop/full_reduction_detail'),
    meta: {
      title: '满减活动详情',
      headType: 0,
      auth: true
    }
  },
  {
    path: '/admin/apply/shop/pickup_point',
    name: 'ShopPickupPoint',
    component: () => import('@/views/apply/shop/pickup_point'),
    meta: {
      title: '自提点管理',
      headType: 0,
      auth: true
    }
  },
  {
    path: '/admin/apply/shop/pickup_point/detail',
    name: 'ShopPickupPointDetail',
    component: () => import('@/views/apply/shop/pickup_point_detail'),
    meta: {
      title: '自提点详情',
      headType: 0,
      auth: true
    }
  },
  {
    path: '/admin/apply/shop/pickup_verifier',
    name: 'ShopPickupVerifier',
    component: () => import('@/views/apply/shop/pickup_verifier'),
    meta: {
      title: '核销人员管理',
      headType: 0,
      auth: true
    }
  },
  {
    path: '/admin/apply/shop/pickup_verifier/detail',
    name: 'ShopPickupVerifierDetail',
    component: () => import('@/views/apply/shop/pickup_verifier_detail'),
    meta: {
      title: '核销人员详情',
      headType: 0,
      auth: true
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/apply/shop.js